/* Homepage Judge.me product context. No review content, rating, author or customer-photo changes. */
(() => {
  'use strict';
  const wrapperSelector = '.jdgm-carousel-wrapper';
  const productSelector = '.jdgm-carousel-item__product';

  function enhance(wrapper) {
    wrapper.querySelectorAll(productSelector).forEach((product) => {
      const image = product.querySelector('img.jdgm-carousel-item__product-image');
      if (!image) return;

      // Reuse only the larger image URL already supplied by the widget; never invent a rendition.
      const retina = image.getAttribute('data-src-retina');
      if (retina) {
        try {
          const url = new URL(retina, document.baseURI);
          if (url.protocol === 'https:' && (url.hostname === 'cdn.shopify.com' || url.origin === location.origin)) {
            if (image.getAttribute('data-src') !== retina) image.setAttribute('data-src', retina);
            const source = image.getAttribute('src');
            // Preserve the widget's lazy loading for images not loaded yet.
            if (source && !source.startsWith('data:') && source !== retina) image.setAttribute('src', retina);
          }
        } catch (_) {
          // A missing or malformed optional rendition must not break the carousel.
        }
      }

      const name = (image.getAttribute('alt') || '').trim();
      const nativeTitle = product.querySelector('.jdgm-carousel-item__product-title');
      let caption = product.querySelector('.am-review-product-name');
      if (!name || (nativeTitle && nativeTitle.textContent.trim())) {
        if (caption) caption.remove();
        return;
      }
      if (!caption) {
        caption = document.createElement('span');
        caption.className = 'am-review-product-name';
        // Keep an existing product link if present; never construct a new link from an alt/title.
        const imageLink = image.closest('a[href]');
        const target = imageLink && product.contains(imageLink) ? imageLink : product;
        target.appendChild(caption);
      }
      if (caption.textContent !== name) caption.textContent = name;
    });
  }

  function collect(node, wrappers) {
    if (!(node instanceof Element)) return;
    const parent = node.closest(wrapperSelector);
    if (parent) wrappers.add(parent);
    node.querySelectorAll(wrapperSelector).forEach((wrapper) => wrappers.add(wrapper));
  }

  function start() {
    if (!document.body || document.body.hasAttribute('data-am-review-products-ready')) return;
    document.body.setAttribute('data-am-review-products-ready', 'true');
    document.querySelectorAll(wrapperSelector).forEach(enhance);
    // Judge.me can arrive late or replace slides. Observe only DOM additions and product metadata,
    // not animation/style mutations; unrelated app updates do not rescan every review.
    const observer = new MutationObserver((records) => {
      const wrappers = new Set();
      records.forEach((record) => {
        const target = record.target instanceof Element ? record.target : record.target.parentElement;
        const wrapper = target && target.closest(wrapperSelector);
        if (wrapper) wrappers.add(wrapper);
        record.addedNodes.forEach((node) => collect(node, wrappers));
      });
      wrappers.forEach(enhance);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['alt', 'data-src-retina']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
